import canAutoplay from 'can-autoplay';
import { deviceAsync } from 'vimmi-web-utils/cjs/deviceAsync';
import $logger from '../logger';

class autoplayStateService {

  autoplayState = null;
  autoplayMutedState = null;
  playChecking = 1;
  timeout;
  mutePlayChecking = 1;

  /**
   * @method checkAutoPlayState
   * @description checks is browser supports autoplay
   * */
  async checkAutoPlayState() {
    if (deviceAsync.isSmartTv()) {
      return true;
    }
    if (this.autoplayState !== null) {
      return this.autoplayState;
    }
    const isAnyMobile = await deviceAsync.isAnyMobile();
    this.timeout = this.timeout || (isAnyMobile ? 8000 : 1000);
    let start = Date.now();
    return canAutoplay.video({
      inline: true,
      timeout: this.timeout
    })
      .then((obj) => {
        let state = !!(obj && obj.result);
        const isTimeOutError = (obj?.error?.message || '').indexOf('Timeout') !== -1;
        $logger.p('checkAutoPlayState').log(state, obj, {
          isTimeOutError, delay: Date.now() - start
        });
        if (!isTimeOutError) {
          this.autoplayState = state;
        } else {
          if (this.playChecking < 2) {
            this.playChecking++;
            this.timeout = isAnyMobile ? 12000 : 5000;
            return this.checkAutoPlayState();
          }
        }
        return state;
      });
  }

  /**
   * @method checkMutedAutoPlayState
   * @description checks is browser supports muted autoplay
   * */
  async checkMutedAutoPlayState() {
    if (this.autoplayMutedState !== null) {
      return this.autoplayMutedState;
    }
    const isAnyMobile = await deviceAsync.isAnyMobile();
    let start = Date.now();
    return canAutoplay.video({
      inline: true,
      muted: true,
      timeout: this.timeout
    })
      .then((obj) => {
        let state = !!(obj && obj.result);
        const isTimeOutError = (obj?.error?.message || '').indexOf('Timeout') !== -1;
        $logger.p('checkMutedAutoPlayState').log(state, obj, {
          isTimeOutError, delay: Date.now() - start
        });
        if (!isTimeOutError) {
          this.autoplayMutedState = state;
        } else {
          if (this.mutePlayChecking < 2) {
            this.mutePlayChecking++;
            this.timeout = isAnyMobile ? 12000 : 5000;
            return this.checkMutedAutoPlayState();
          }
        }
        return state;
      });
  }
}

const autoplayState = new autoplayStateService();

export default autoplayState;
